import { financePalette } from './chunk-AEFY5JL4.mjs';
import { createTheme, responsiveFontSizes } from '@mui/material/styles';

var menuPaper = {
  backgroundColor: "rgba(26, 26, 62, 0.92)",
  backdropFilter: "blur(24px)",
  WebkitBackdropFilter: "blur(24px)"
};
var glassmorphismTheme = createTheme({
  palette: {
    mode: "dark",
    finance: financePalette,
    background: {
      default: "transparent",
      paper: "rgba(255, 255, 255, 0.05)",
      // Fully opaque surface for the playing list, which slides up over the
      // player controls and must hide them completely. Menus use a 0.92 glass
      // tint because they float over a page, but this panel covers same-card
      // content, so it goes solid (the opaque form of the menu hue). Typed in
      // `./domainPalette`.
      overlay: "rgb(26, 26, 62)"
    },
    primary: {
      main: "#667eea",
      light: "#8b9feb",
      dark: "#4c63d2",
      contrastText: "#ffffff"
    },
    secondary: {
      main: "#764ba2",
      light: "#9a7ab8",
      dark: "#5a3a7c",
      contrastText: "#ffffff"
    },
    text: {
      primary: "rgba(255, 255, 255, 0.9)",
      secondary: "rgba(255, 255, 255, 0.6)",
      disabled: "rgba(255, 255, 255, 0.4)"
    },
    divider: "rgba(255, 255, 255, 0.1)"
  },
  shape: {
    borderRadius: 8
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif'
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(255, 255, 255, 0.05)",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.37)"
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
          border: "1px solid rgba(255, 255, 255, 0.2)",
          boxShadow: "0 4px 16px rgba(0, 0, 0, 0.2)",
          transition: "all 0.3s ease",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.15)",
            boxShadow: "0 6px 20px rgba(0, 0, 0, 0.3)",
            transform: "translateY(-2px)"
          }
        },
        contained: {
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          border: "none",
          "&:hover": {
            background: "linear-gradient(135deg, #7b91f0 0%, #8a6ab8 100%)"
          }
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(255, 255, 255, 0.05)",
          backdropFilter: "blur(16px)",
          WebkitBackdropFilter: "blur(16px)",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.37)"
        }
      }
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(15, 15, 30, 0.7)",
          backdropFilter: "blur(20px)",
          WebkitBackdropFilter: "blur(20px)",
          borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
          boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)"
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          // Opaque enough to keep content legible over the backdrop scrim.
          backgroundColor: "rgba(26, 26, 62, 0.92)",
          backdropFilter: "blur(24px)",
          WebkitBackdropFilter: "blur(24px)",
          border: "1px solid rgba(255, 255, 255, 0.15)",
          boxShadow: "0 16px 64px rgba(0, 0, 0, 0.5)"
        }
      }
    },
    MuiMenu: {
      styleOverrides: {
        paper: menuPaper
      }
    },
    MuiPopover: {
      styleOverrides: {
        paper: menuPaper
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            backgroundColor: "rgba(255, 255, 255, 0.05)",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
            borderRadius: 12,
            "& fieldset": {
              borderColor: "rgba(255, 255, 255, 0.1)"
            },
            "&:hover fieldset": {
              borderColor: "rgba(255, 255, 255, 0.2)"
            },
            "&.Mui-focused fieldset": {
              borderColor: "#667eea"
            }
          }
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(255, 255, 255, 0.08)",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.12)"
          }
        },
        filled: {
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          border: "none"
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: "rgba(255, 255, 255, 0.7)",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.1)"
          }
        }
      }
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          background: "linear-gradient(135deg, #0f0f1e 0%, #1a1a3e 50%, #2a2a5e 100%)",
          minHeight: "100vh",
          backgroundAttachment: "fixed"
        }
      }
    }
  }
});
var theme = responsiveFontSizes(glassmorphismTheme);

export { theme };
//# sourceMappingURL=chunk-7JGQWJZ6.mjs.map
//# sourceMappingURL=chunk-7JGQWJZ6.mjs.map